var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLsqChevronUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77593 5.10869C7.53185 5.35277 7.13612 5.35277 6.89204 5.10869L4.00065 2.2173L1.10926 5.10869C0.865182 5.35277 0.469453 5.35277 0.225377 5.10869C-0.0187016 4.86461 -0.0187016 4.46888 0.225377 4.22481L3.55871 0.891473C3.80279 0.647395 4.19852 0.647395 4.44259 0.891473L7.77593 4.22481C8.02 4.46888 8.02 4.86461 7.77593 5.10869Z",
    fill: "#0A1F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsqChevronUp);
export default __webpack_public_path__ + "static/media/lsq_chevron_up.a728093d553d38489ad2854e9f75c9f9.svg";
export { ForwardRef as ReactComponent };